"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _axios = _interopRequireDefault(require("axios"));

var _Grid = _interopRequireDefault(require("@material-ui/core/Grid"));

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

var _getLocals = _interopRequireDefault(require("../utils/getLocals"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Webcam = /*#__PURE__*/(0, _react.lazy)(function () {
  return import(
  /* webpackChunkName: "reactWebcam" */
  "./webcam");
});

var ReactWebcams01 = function ReactWebcams01(_ref) {
  var _data$webcams, _data$webcams2;

  var client = _ref.client,
      gridBreakpoints = _ref.gridBreakpoints,
      _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      _ref$live = _ref.live,
      live = _ref$live === void 0 ? true : _ref$live,
      location = _ref.location,
      _ref$overlaySize = _ref.overlaySize,
      overlaySize = _ref$overlaySize === void 0 ? "large" : _ref$overlaySize,
      region = _ref.region,
      _ref$showLocation = _ref.showLocation,
      showLocation = _ref$showLocation === void 0 ? true : _ref$showLocation,
      _ref$skeletonItems = _ref.skeletonItems,
      skeletonItems = _ref$skeletonItems === void 0 ? 12 : _ref$skeletonItems,
      url = _ref.url;
  var locals = (0, _getLocals.default)(lang);

  var _useState = (0, _react.useState)(),
      _useState2 = _slicedToArray(_useState, 2),
      data = _useState2[0],
      setData = _useState2[1];

  var fallbackImage = "/img/fallback.jpg";
  (0, _react.useEffect)(function () {
    function fetchData() {
      return _fetchData.apply(this, arguments);
    }

    function _fetchData() {
      _fetchData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                params = [];

                if (lang) {
                  params.push("lang=" + lang);
                }

                if (client) {
                  params.push("client=" + client);
                }

                if (region) {
                  params.push("region=" + region);
                }

                if (location) {
                  params.push("location=" + location);
                }

                _context.prev = 5;
                _context.next = 8;
                return _axios.default.post(url + "?" + params.join("&"), null);

              case 8:
                result = _context.sent;
                setData(result === null || result === void 0 ? void 0 : result.data);
                _context.next = 15;
                break;

              case 12:
                _context.prev = 12;
                _context.t0 = _context["catch"](5);
                setData({});

              case 15:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[5, 12]]);
      }));
      return _fetchData.apply(this, arguments);
    }

    fetchData();
  }, [client, lang, location, region, url]); // no result

  if (data && (data === null || data === void 0 ? void 0 : (_data$webcams = data.webcams) === null || _data$webcams === void 0 ? void 0 : _data$webcams.length) === 0) {
    var _locals$fallbackInfo;

    return /*#__PURE__*/_react.default.createElement(_Alert.default, {
      severity: "error"
    }, locals === null || locals === void 0 ? void 0 : (_locals$fallbackInfo = locals.fallbackInfo) === null || _locals$fallbackInfo === void 0 ? void 0 : _locals$fallbackInfo.label);
  }

  var items = data === null || data === void 0 ? void 0 : (_data$webcams2 = data.webcams) === null || _data$webcams2 === void 0 ? void 0 : _data$webcams2.map(function (_ref2) {
    var id = _ref2.id,
        location = _ref2.location,
        imageUrl = _ref2.imageUrl,
        teaserImageUrl = _ref2.teaserImageUrl,
        title = _ref2.title,
        viewerUrl = _ref2.viewerUrl;
    // check if valid image
    var image = fallbackImage;

    if (imageUrl && /jpg|jpeg|png|webp/.test(imageUrl)) {
      image = imageUrl;
    } else if (teaserImageUrl && /jpg|jpeg|png|webp/.test(teaserImageUrl)) {
      image = teaserImageUrl;
    } else {
      image = fallbackImage;
    }

    return /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
      item: true,
      key: id
    }, gridBreakpoints ? _objectSpread({}, gridBreakpoints) : {
      xs: 12,
      sm: 6,
      md: 4
    }), /*#__PURE__*/_react.default.createElement(Webcam, {
      image: image,
      link: viewerUrl,
      live: live,
      location: location,
      overlaySize: overlaySize,
      showLocation: showLocation,
      title: title
    }));
  });

  var skeleton = _toConsumableArray(Array(skeletonItems)).map(function (x, i) {
    return /*#__PURE__*/_react.default.createElement(_Grid.default, _extends({
      item: true,
      key: i
    }, gridBreakpoints ? _objectSpread({}, gridBreakpoints) : {
      xs: 12,
      sm: 6,
      md: 4
    }), /*#__PURE__*/_react.default.createElement(Webcam, {
      showLocation: showLocation,
      skeleton: true
    }));
  });

  return /*#__PURE__*/_react.default.createElement(_Grid.default, {
    container: true,
    spacing: 3
  }, items ? items : skeleton);
};

ReactWebcams01.propTypes = {
  client: _propTypes.default.string.isRequired,
  gridBreakpoints: _propTypes.default.object,
  lang: _propTypes.default.string,
  live: _propTypes.default.bool,
  location: _propTypes.default.string,
  overlaySize: _propTypes.default.oneOf(["xsmall", "small", "medium", "large", "xlarge"]),
  region: _propTypes.default.string.isRequired,
  showLocation: _propTypes.default.bool,
  skeletonItems: _propTypes.default.number,
  url: _propTypes.default.string.isRequired
};
var _default = ReactWebcams01;
exports.default = _default;